/*global angular */
define(
    "diy/undo-redo/historyEntry/Layout",
    [
        'diy/undo-redo/historyEntry/Base',
    ],
    /**
     *
     * @param {module.undoRedo.HistoryEntry.Base} HistoryEntry
     * @returns {*}
     */
    function (HistoryEntry) {
        'use strict';
        var Layout;
        /**
         * @class module.undoRedo.HistoryEntry.Layout
         * @template module.undoRedo.HistoryEntry.Layout
         * @lends {module.undoRedo.HistoryEntry.Layout.prototype}
         * @extends {module.undoRedo.HistoryEntry.Base}
         * @constructor
         */
        Layout = HistoryEntry.extend({
            onExecutedLast: function (executionData) {
                // does nothing, it has no output in client side
            },

            onExecuted: function (executionData) {

                this.api.requestBrowserReload();

                return this._super(executionData);
            },

            unserialize: function (serializedObject) {

                this.payload = serializedObject;

                return this._super(serializedObject);
            },

            serialize: function () {
                return this.payload;
            }
        });
        return Layout;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/historyEntry/Layout.js
 ** module id = 901
 ** module chunks = 0
 **/